module.exports = __webpack_public_path__ + "static/media/provider-photo-primary.db1d546f.jpg";